import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearBackendRescheduleDetectedAction = (state: PlanboardState) => {
  state.backendRescheduleDetected = null;
};
